import { Card, CardContent, Grid, Theme, Typography } from '@mui/material';
import BodyTemplate from 'components/_layout/navigation/BodyTemplate';
import { useAuthenticated } from 'hooks';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const Gdprpage: FC = () => {
  const { t } = useTranslation();
  const isAuthenticate = useAuthenticated();

  const linkStyle = {
    a: {
      color: (theme: Theme) => theme.palette.text.primary,
      fontWeight: 500,
      textDecoration: 'none',
      '&[href^="https"], &[href^="mailto"]': {
        borderBottom: (theme: Theme) => `2px solid ${theme.palette.primary.main}`,
        transition: (theme: Theme) => `border-bottom ${theme.transitions.duration.enteringScreen}ms  ${theme.transitions.easing.easeOut} 0ms`,
        ':hover': {
          borderColor: (theme: Theme) => theme.palette.common.black,
        },
      },
    },
    'li>a:hover': {
      borderBottom: (theme: Theme) => `2px solid ${theme.palette.common.black}`,
    },
  };

  return (
    <BodyTemplate title={t(`bodyTemplate.gdpr`)} backButton={!isAuthenticate}>
      <Grid container direction='row' spacing={11}>
        <Grid item sm={12}>
          <Card
            sx={{
              mt: 2,
              ml: 2,
              mr: 2,
              width: 'auto',
            }}
          >
            <CardContent>
              <Typography sx={linkStyle} dangerouslySetInnerHTML={{ __html: t('gdpr.html_text') }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </BodyTemplate>
  );
};

export default Gdprpage;
